import React from 'react'
import moment from 'moment'
import { formatDayStartTime, formatTimespan } from '@/app/common/dateHelper'
import { DayType } from '../constants/DayType'
import { dayTypeCategories } from '../constants/DayTabs'

const DayTime = ({
  dayStartTime,
  dayScheduleTime,
  showSchedule,
  dayType,
}: {
  dayStartTime?: any
  dayScheduleTime?: any
  showSchedule?: boolean
  dayType?: DayType
}) => {
  const isWorkingDay =
    dayType != null && dayTypeCategories.work.includes(dayType)

  const shouldRender = showSchedule ? isWorkingDay : true

  if (!shouldRender) return null

  return (
    <div className="tw-flex tw-flex-col tw-items-start tw-pl-[2px]">
      <p className="tw-text-[9px] tw-font-normal tw-text-[#1F2937]">
        {dayStartTime && formatDayStartTime(moment(dayStartTime).toDate())}
      </p>
      <p className="tw-text-[9px] tw-font-normal tw-text-[#1F2937]">
        {dayScheduleTime && formatTimespan(dayScheduleTime)}
      </p>
    </div>
  )
}

export default DayTime
